import en from '@/assets/flags/rounded/110-united-kingdom.svg'
import zh from '@/assets/flags/rounded/011-china.svg'
import it from '@/assets/flags/rounded/263-italy.svg'
import th from '@/assets/flags/rounded/088-thailand.svg'
import pt from '@/assets/flags/rounded/098-portugal.svg'
import es from '@/assets/flags/rounded/230-spain.svg'
import fr from '@/assets/flags/rounded/197-france.svg'
import ro from '@/assets/flags/rounded/213-romania.svg'
import ru from '@/assets/flags/rounded/044-russia.svg'
import pl from '@/assets/flags/rounded/165-poland.svg'
import hu from '@/assets/flags/rounded/210-hungary.svg'
import de from '@/assets/flags/rounded/208-germany.svg'
import ja from '@/assets/flags/rounded/241-japan.svg'
import sl from '@/assets/flags/rounded/259-slovenia.svg'
import ko from '@/assets/flags/rounded/219-south_korea.svg'
import nl from '@/assets/flags/rounded/077-netherlands.svg'
import uk from '@/assets/flags/rounded/198-ukraine.svg'
import hr from '@/assets/flags/rounded/128-croatia.svg'

import Logo from '@/assets/logo.svg'

import { langList } from '@/locales/i18n'
import { setCrossDomainCookie } from '@gto/helpers/cookies'

const lang_mix = {
  data() {
    return {}
  },
  methods: {
    handleChange(v) {
      this.selectedLang = v
    },
  },
  computed: {
    langs() {
      return [
        {
          name: 'Translation-team',
          id: 'tteam',
          flag: Logo,
          noFalback: true,
          exception: this.hasTKeys,
        },
        { name: 'English', id: 'en', flag: en },
        { name: 'Ukrainian', id: 'uk', flag: uk },
        { name: 'Chinese', id: 'zh', flag: zh },
        { name: 'Portugese', id: 'pt', flag: pt },
        { name: 'Spanish', id: 'es', flag: es },
        { name: 'French', id: 'fr', flag: fr },
        { name: 'Italian', id: 'it', flag: it },
        { name: 'Thai', id: 'th', flag: th },
        { name: 'Romanian', id: 'ro', flag: ro },
        { name: 'Polish', id: 'pl', flag: pl },
        { name: 'Hungarian', id: 'hu', flag: hu },
        { name: 'Korean', id: 'ko', flag: ko },
        { name: 'German', id: 'de', flag: de },
        { name: 'Japanese', id: 'ja', flag: ja },
        { name: 'Slovenian', id: 'sl', flag: sl },
        { name: 'Dutch', id: 'nl', flag: nl },
        { name: 'Croatian', id: 'hr', flag: hr },
        { name: 'Russian', id: 'ru', flag: ru },
      ].filter(i => i.exception || langList.includes(i.id))
    },
    hasTKeys() {
      return (
        this.$store.getters.user_has_flag('TTEAM') ||
        import.meta.env.VITE_BRANCH !== 'master' ||
        import.meta.env.VITE_ENV !== 'production'
      )
    },
    lang() {
      let res = this.$i18n.locale || 'en'
      res = this.langs.find(i => i.id === res)
      return res
    },
    selectedLang: {
      get() {
        let res = this.$i18n.locale || 'en'
        res = this.langs.find(i => i.id === res)
        return res ? res.id : 'en'
      },
      set(lang) {
        const id = lang.id || lang
        setCrossDomainCookie('GTO_LANGUAGE', id, 365)
        localStorage.setItem('lang', id) // dev purposes
        this.$i18n.locale = id

        // for dev and translation-team to show i18n keys
        if (this.hasTKeys) {
          this.$i18n.fallbackLocale = lang.noFalback ? '' : 'en'
        }
        window.dispatchEvent(new CustomEvent('languageChange', { detail: { lang: id } }))
      },
    },
  },
}

export default lang_mix
